/**
 * Reducer Creater
 */
const creater = (actionsMap, initialState) => (state = initialState, action = {}) => {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
};

export default creater;
